import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import { requestConversation } from "@/lib/conversation";

const STEPS = [
  {
    n: "01",
    title: "Tell us your idea.",
    body: "One sentence is enough.",
  },
  {
    n: "02",
    title: "Your Producer designs the blueprint.",
    body: "Creative. Strategy. Budget. Timeline. Crew. Everything planned.",
  },
  {
    n: "03",
    title: "You approve. We produce.",
    body: "From blueprint to final delivery. Anywhere in the world.",
  },
];

export default function HowItWorks() {
  return (
    <div className="min-h-screen bg-white text-ink flex flex-col">
      <Nav />

      <main className="flex-1">
        <section className="max-w-[1280px] mx-auto px-6 md:px-10 pt-24 md:pt-40 pb-16 md:pb-24">
          <Reveal>
            <div className="eyebrow eyebrow-denim mb-8">How It Works</div>
          </Reveal>
          <Reveal as="h1" delay={80} className="font-display font-extrabold text-[44px] sm:text-[64px] md:text-[88px] tracking-[-0.045em] leading-[0.96] text-ink max-w-[1000px]">
            Three <span className="font-serif-italic font-light">simple</span> steps.
          </Reveal>
        </section>

        <section className="max-w-[1280px] mx-auto px-6 md:px-10 pb-32 md:pb-48">
          <div className="border-t border-bnm">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 120}>
                <div
                  className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-b border-bnm"
                  data-testid={`how-step-${s.n}`}
                >
                  <div className="md:col-span-2 eyebrow eyebrow-denim">{s.n}</div>
                  <div className="md:col-span-5">
                    <h2 className="font-display font-semibold text-[24px] md:text-[34px] tracking-[-0.025em] leading-[1.1] text-ink">
                      {s.title}
                    </h2>
                  </div>
                  <div className="md:col-span-5">
                    <p className="text-muted-ink text-[15.5px] md:text-[17px] leading-[1.7] max-w-[460px] whitespace-pre-line">
                      {s.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={100}>
            <div className="mt-20 md:mt-28 flex flex-col items-center text-center gap-6">
              <h3 className="font-display font-extrabold text-[34px] sm:text-[48px] md:text-[64px] tracking-[-0.04em] leading-[1.0]">
                Ready when you are.
              </h3>
              <Link
                to="/"
                onClick={() => requestConversation()}
                className="btn-denim"
                data-testid="how-cta-start"
              >
                <span>Start your project</span>
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </Reveal>
        </section>
      </main>

      <Footer />
    </div>
  );
}
